import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from "../../atoms/dialog";
import Configurations from "../../tabs/Configurations"
import { getDetailsFromUrl } from '../../../services/blueprint';

export default function ConfigurationsAlert({ onClose }) {

    const {screen} =  getDetailsFromUrl();
    const browserTabTitle = screen == "teams" ? "Team" : screen == "assets" ? "Assets" : screen == "system-model" ?  "System Model" : screen == "transaction" ? "Transaction" : screen == "testsuite" ? "Simulation" : screen == "view" ? "View" : "Blueprint" ;


    return (
        <Dialog
            title={"Configuration"}
            handleClose={() => onClose()}
            open={true}
            paperProps={{ style: { width: 1500, maxWidth: 1500 }, id: "configurationsModal" }}
        >
            <Configurations browserTabTitle={browserTabTitle} />
            <Grid container direction="row" alignItems="center" justify="center" style={{ paddingRight: 25, justifyContent: 'end' }}>
                <Button onClick={onClose} variant="contained" style={{textTransform: 'capitalize'}}>
                    Close
                </Button>
            </Grid>

        </Dialog>
    )
}